// Module
var code = "\n<div class=\"cell media-list\">\n    <tpl for=\"media\">\n        <div class=\"media-list-body\">\n            <img crossorigin=\"anonymous\" data-errorhandling=\"1\" data-id=\"{id}\" class=\"media-list-body-ThumbnailImage\" src=\"{url}\" />\n        </div>\n    </tpl>\n</div>\n";
// Exports
module.exports = code;